import { StateCreator } from 'zustand'
import { ContextState } from './types'

export const createContextSlice: StateCreator<ContextState> = () => ({
  pageContext: { title: '', type: '', router: null, inlineTickerMessages: [] },
  searchContext: {
    departments: [],
    redirectedFrom: undefined,
    redirectionSource: undefined,
    departmentCounts: [],
    searchTerm: '',
    correctedSearchTerm: '',
    selectedSuggestion: undefined,
    isTrendingSuggestion: false,
    promotionId: undefined,
    sponsoredProducts: [],
    inlineTickerMessages: [],
  },
  recipientsWithReminders: [],
  isAuthenticated: false,
})
